import { DataChannel } from './channel';

export const projectListChannel = {
  loadedFile: new DataChannel<number>(),
  paneExpanded: new DataChannel<number | 'none'>(),
};
